import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BaZiChart as ChartType } from '../utils/baziCalculator';
import { ElementBadge } from './ElementBadge';
interface BaZiChartProps {
  chart: ChartType;
  showDetails?: boolean;
}
export const BaZiChart: React.FC<BaZiChartProps> = ({
  chart,
  showDetails = true
}) => {
  const pillars = [{
    label: '时柱',
    data: chart.hour
  }, {
    label: '日柱',
    data: chart.day
  }, {
    label: '月柱',
    data: chart.month
  }, {
    label: '年柱',
    data: chart.year
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <motion.div variants={container} initial="hidden" animate="show" className="w-full max-w-4xl mx-auto bg-white ink-border rounded-lg p-6 md:p-8 shadow-lg" data-id="element-14">
      <div className="grid grid-cols-4 gap-2 md:gap-6 text-center" data-id="element-15">
        {pillars.map((pillar, idx) => <motion.div key={idx} variants={item} className="flex flex-col items-center space-y-4" data-id="element-16">
            <div className="text-gold-dark font-serif text-sm md:text-base border-b border-gold/30 pb-2 w-full" data-id="element-17">
              {pillar.label}
            </div>

            {showDetails && <div className="text-xs md:text-sm text-ink-light h-6 font-medium" data-id="element-18">
                {pillar.label === '日柱' ? <span className="text-gold-dark font-bold" data-id="element-19">日主</span> : pillar.data.shiShen}
              </div>}

            <ElementBadge char={pillar.data.stem.name} element={pillar.data.stem.element} size="lg" data-id="element-20" />
            <ElementBadge char={pillar.data.branch.name} element={pillar.data.branch.element} size="lg" data-id="element-21" />

            {showDetails && <div className="flex flex-col space-y-2 mt-4 min-h-[80px]" data-id="element-22">
                {pillar.data.hiddenStems.map((hs, i) => <div key={i} className="flex items-center justify-center space-x-1 text-xs md:text-sm" data-id="element-23">
                    <span className="text-ink-light w-8 text-right" data-id="element-24">
                      {hs.shiShen}
                    </span>
                    <span className="font-bold" style={{
              color: `var(--color-element-${hs.stem.element})`
            }} data-id="element-25">
                      {hs.stem.name}
                    </span>
                  </div>)}
              </div>}

            {showDetails && <div className="mt-4 pt-4 border-t border-paper-dark w-full flex flex-col space-y-2" data-id="element-26">
                <div className="text-xs md:text-sm text-jade font-medium" data-id="element-27">
                  {pillar.data.naYin}
                </div>
                <div className="flex flex-wrap justify-center gap-1" data-id="element-28">
                  {pillar.data.shenSha.map((ss, i) => <span key={i} className="text-[10px] md:text-xs bg-paper px-1.5 py-0.5 rounded text-cinnabar border border-cinnabar/20" data-id="element-29">
                      {ss}
                    </span>)}
                </div>
              </div>}
          </motion.div>)}
      </div>
    </motion.div>;
};